import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

import { EventActions } from "../../../../../redux/actions";
import { allSharedComponents } from "../../../../../shared";
import {
  calculateVAT,
  dateToUTCWithTimezone,
  formatDateTimeRangeFromServer,
  precisionCalculation,
  serverFormatToMomentObject,
  toSingleDateStringIfEqual,
} from "../../../../../system";
import {
  LogoPlaceholder,
  LocationIcon,
  CalendarIcon,
  TimeIcon,
} from "../../../../../assets/images/icon";
import {
  calculationOperations,
  Directions,
  eventConstants,
  subscriptionTypeConstants,
  timezoneConstants,
  translationConstants,
  viewPathConstants,
} from "../../../../../constants";

const { StopPropagation, ServerFormatToDate } = allSharedComponents;

const EventCard = ({ event, city, setSelectedEvent, isUpcomingTab = true }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [registrationClosed, setRegistrationClosed] = useState(false);
  const [registrationNotStarted, setRegistrationNotStarted] = useState(false);
  const [registrationPrice, setRegistrationPrice] = useState(0);

  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  useEffect(() => {
    const currentDate = dateToUTCWithTimezone(); // Current date in seconds
    if (
      currentDate.isSameOrBefore(
        serverFormatToMomentObject(event?.registrationStartDateString)
      )
    ) {
      setRegistrationNotStarted(true);
    } else if (
      currentDate.isSameOrAfter(
        serverFormatToMomentObject(event?.registrationEndDateString)
      )
    ) {
      setRegistrationClosed(true);
    }
  }, [event?.registrationStartDateString, event?.registrationEndDateString]);

  useEffect(() => {
    const vat = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );
    if (event?.registrationFee && vat) {
      const totalPrice = precisionCalculation(
        calculateVAT(vat?.price, event?.registrationFee),
        event?.registrationFee,
        calculationOperations.addition
      );
      setRegistrationPrice(totalPrice);
    }
  }, [event, subscriptionPrices]);

  const viewDetail = () => {
    dispatch(EventActions.resetGetEventById());
    navigate(
      `${viewPathConstants.VIEW_EVENT_DETAIL}?${eventConstants.EVENT_ID}=${event?.id}`,
      {
        state: {
          eventId: event?.id,
          isActive: event?.isActive,
        },
      }
    );
  };

  return (
    <>
      <div className="col-md-12 py-2 text-black">
        <div
          className="activity-card cast-shadow-on-hover"
          onClick={() => {
            viewDetail();
          }}
        >
          <div className="row m-0 gap-md-0">
            <div className="col-md-1 col-lg-1 d-none d-md-none d-lg-block d-flex justify-content-md-center align-items-md-center px-1 text-md-center">
              <span className="activity-date" dir={Directions.ltr}>
                <ServerFormatToDate dateString={event?.startDateString} />
              </span>
            </div>
            <div className="col-12 col-md-10 col-lg-5">
              <div className="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center justify-content-md-start gap-4">
                <div className="row w-100">
                  <div className="col-5 col-md-4 col-lg-4 d-lg-flex gap-3 justify-content-start">
                    <div className="competition-content-wrapper"></div>
                    <div
                      className={`activity-card-image-wrapper ${
                        isMobile ? "h-100" : "h-100px"
                      }`}
                    >
                      <img
                        src={
                          event?.logo?.link
                            ? event?.logo?.link
                            : LogoPlaceholder
                        }
                        alt="Event Logo"
                      />
                    </div>
                  </div>
                  <div className="col-7 col-md-5 col-lg-7 ps-3 d-flex flex-column justify-content-between">
                    <div className="d-flex flex-column">
                      <h5 className="fw-800 text-ellipsis">
                        {direction === Directions.rtl && event?.arabicTitle
                          ? `${event?.arabicTitle}`
                          : `${event?.title}`}
                      </h5>
                    </div>
                    <div className="">
                      <div className="d-flex gap-1 flex-column">
                        <div className="contact-information-card pt-md-2 d-flex gap-2 pt-0">
                          <img alt="" name="activitySpot" src={LocationIcon} />
                          <span
                            className={`${isMobile ? "font-12" : "font-14"}`}
                          >
                            {direction === Directions.rtl
                              ? event?.spotInfo?.arabicSpotName ||
                                event?.spotInfo?.spotName
                              : event?.spotInfo?.spotName}
                            {direction === Directions.rtl
                              ? city?.arabicName || city?.name
                              : city?.name}
                          </span>
                        </div>

                        <div className="row">
                          <div className="d-lg-flex ">
                            <div className="col-12 col-md-12 col-lg-12">
                              <div
                                className={`contact-information-card pt-1 d-flex gap-2 "`}
                              >
                                <img
                                  alt=""
                                  name="activityDate"
                                  src={CalendarIcon}
                                />
                                <span
                                  className={`${
                                    isMobile ? "font-12" : "font-14"
                                  }`}
                                >
                                  {toSingleDateStringIfEqual(
                                    event?.startDateString,
                                    event?.endDateString
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`d-block d-md-none contact-information-card-wrapper ${
                            isMobile ? "font-12" : "font-14"
                          }`}
                        >
                          <div className="contact-information-card d-flex gap-2">
                            <img alt="" name="activityDate" src={TimeIcon} />
                            <span>
                              {formatDateTimeRangeFromServer(
                                event?.startDateString,
                                event?.endDateString,
                                timezoneConstants.hourMinuteFormat
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 mt-3 mt-md-0 gap-2 d-flex justify-content-between">
              <div className="col-5 col-md-5 col-lg-8 h-100 flex-wrap d-flex justify-content-between">
                <div className="col-md-7 col-12 d-flex flex-column justify-content-between">
                  <div>
                    {isUpcomingTab && event?.isPublicRegistrationAllowed && (
                      <>
                        {!registrationClosed &&
                          (registrationNotStarted ? (
                            <span
                              className={`timeLogDesign text-center text-md-start ${
                                isMobile ? "font-12" : "font-14"
                              }`}
                            >
                              {event?.registrationStartsInDays > 1
                                ? `${t(
                                    translationConstants.registration_starts_in
                                  )} ${event?.registrationStartsInDays} ${t(
                                    translationConstants.days
                                  )}`
                                : event?.registrationStartsInDays === 1
                                ? `${t(
                                    translationConstants.registration_starting_tomorrow
                                  )}`
                                : `${t(
                                    translationConstants.registration_starting_today
                                  )}`}
                            </span>
                          ) : (
                            <span
                              className={`timeLogDesign text-center text-md-start ${
                                isMobile ? "font-10" : "font-14"
                              }`}
                            >
                              {event?.registrationEndsInDays > 1
                                ? `${t(
                                    translationConstants.registration_ending_in
                                  )} ${event?.registrationEndsInDays} ${t(
                                    translationConstants.days
                                  )}`
                                : event?.registrationEndsInDays === 1
                                ? `${t(
                                    translationConstants.registration_ending_tomorrow
                                  )}`
                                : `${t(
                                    translationConstants.registration_ending_today
                                  )}`}
                            </span>
                          ))}
                      </>
                    )}
                  </div>
                  <div className="d-none d-md-block contact-information-card-wrapper">
                    <div className="contact-information-card">
                      <img alt="" name="activityDate" src={TimeIcon} />
                      <span>
                        {formatDateTimeRangeFromServer(
                          event?.startDateString,
                          event?.endDateString,
                          timezoneConstants.hourMinuteFormat
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 col-12 d-flex flex-column">
                  {isUpcomingTab && (
                    <>
                      {event?.maximumParticipantsAllowed > 0 &&
                        event?.isPublicRegistrationAllowed &&
                        !registrationClosed && (
                          <div
                            className={`seatsAvailableCard ${
                              isMobile ? "w-100" : "w-100px"
                            } px-2 mx-md-3 mx-0`}
                          >
                            <h1 className="m-0 p-0 fw-700">
                              {event?.seatsAvailable}
                            </h1>
                            <h6 className="font-12 text-center">
                              {t(translationConstants.SEATS_AVAILABLE)}
                            </h6>
                          </div>
                        )}
                    </>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-5 col-lg-4 d-flex justify-content-md-center ps-2 ps-md-0 align-items-center">
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  {isUpcomingTab &&
                    (event?.isPublicRegistrationAllowed ? (
                      <div className="d-flex align-items-center justify-content-end flex-column gap-1">
                        {!registrationClosed &&
                          event.registrationFee &&
                          event.registrationFee !== 0 && (
                            <>
                              <h6 className="font-14 m-0 p-0">
                                {t(translationConstants.registration_fees)}
                              </h6>
                              <h5 className="font-14 fw-bold m-0">
                                {translationConstants.SAR} {registrationPrice}
                              </h5>
                            </>
                          )}
                        {!registrationClosed &&
                          event.specialMembersDiscount &&
                          event.specialMembersDiscount > 0 && (
                            <span>
                              <h6 className="font-10 m-0 py-1">
                                {parseFloat(
                                  event.specialMembersDiscount
                                ).toFixed(2)}{" "}
                                % {t(translationConstants.discount_for_members)}
                              </h6>
                            </span>
                          )}
                        {registrationNotStarted ? (
                          <>
                            <StopPropagation>
                              <Button
                                className="Registeration-button-event m-0 fw-medium font-18 bg-gray-background"
                                type="button"
                                disabled={true}
                              >
                                {t(translationConstants.register)}
                              </Button>
                            </StopPropagation>
                          </>
                        ) : registrationClosed ? (
                          <span className="font-12 underline">
                            {t(translationConstants.registration_closed)}
                          </span>
                        ) : (
                          <>
                            {event?.seatsAvailable > 0 ? (
                              <>
                                <StopPropagation>
                                  <Button
                                    className="Registeration-button-event m-0 fw-medium font-18"
                                    type="button"
                                    onClick={() => {
                                      setSelectedEvent(event?.id);
                                    }}
                                  >
                                    {t(translationConstants.REGISTER_NOW)}
                                  </Button>
                                </StopPropagation>
                              </>
                            ) : (
                              <StopPropagation>
                                <Button
                                  className="Registeration-button-event m-0 fw-medium font-18 bg-gray-background"
                                  type="button"
                                  disabled={true}
                                >
                                  {t(translationConstants.REGISTER_NOW)}
                                </Button>
                              </StopPropagation>
                            )}
                          </>
                        )}
                      </div>
                    ) : (
                      <StopPropagation>
                        <Button
                          className="Registeration-button-event m-0 fw-medium font-18 bg-gray-background-dark"
                          type="button"
                          disabled={true}
                        >
                          {t(translationConstants.invite_only)}
                        </Button>
                      </StopPropagation>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventCard;
